function MuseIframePage() {
	return (
		<div className="pt-32 p-site-x flex-1 flex flex-col items-center justify-center">
			<iframe src="/muse2/index.html" width="80%" className="flex-1" />
		</div>
	);
}

export default MuseIframePage;
